import React, { Component } from 'react';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import * as actions from '../../actions/settings';

class UpdateBillingEmailForm extends Component {
	constructor(props) {
		super(props);
		this.submit = this.submit.bind(this);
		this.history = this.props.history;
		this.state = { loading: false, newEmail: '' };
	}

	async submit() {
		this.setState({ loading: true });
		const { newEmail } = this.state;

		const updateData = await this.props.updateBillingEmail(newEmail);
		if (updateData.error) {
			// don't close the dialog, just show error
		} else {
			this.props.setBillingEmail();
			this.props.closeDialog();
		}
		this.setState({ loading: false });
	}

	renderButtons = () => {
		if (this.state.loading) {
			return (
				<div style={{ textAlign: 'center' }}>
					<CircularProgress />
				</div>
			);
		}
		return (
			<DialogActions>
				<Button
					variant="text"
					color="primary"
					onClick={() => this.props.closeDialog(false)}
				>
					Cancel
				</Button>
				<Button
					color="primary"
					variant="contained"
					onClick={this.submit}
				>
					Update
				</Button>
			</DialogActions>
		);
	};

	render() {
		return (
			<div>
				<TextField
					label="Email"
					variant="outlined"
					color="primary"
					fullWidth
					onChange={(event) => {
						this.setState({ newEmail: event.target.value });
					}}
				/>

				<div className="right-align">{this.renderButtons()}</div>
			</div>
		);
	}
}

export default connect(null, actions)(UpdateBillingEmailForm);



// WEBPACK FOOTER //
// ./src/components/settings/UpdateBillingEmailForm.js